import { List, ListItem, Typography } from '@mui/material';
import React from 'react';
import { DetailsOptions, DetailsSectionsProps } from './Components/SlideoutInbox';
import { Inbox } from './index';

const AdditionalDetails: React.FC<DetailsSectionsProps> = (props) => {
    return (
        <>
            <Typography variant='h6'>Additional Data</Typography>
            <List>
                {Object.entries(props.notification.additionalData ?? {}).map(([key, value]) => (
                    <ListItem key={key}>{`${key}: ${value}`}</ListItem>
                ))}
            </List>
        </>
    );
};

export default (): React.ReactElement => {
    const detailsOptions: DetailsOptions = {
        additionalDetails: (props) => <AdditionalDetails notification={props.notification} />,
    };

    return (
        <Inbox
            options={{
                details: detailsOptions,
            }}
        />
    );
};


export const src = "import { List, ListItem, Typography } from '@mui/material';\nimport React from 'react';\nimport { DetailsOptions, DetailsSectionsProps } from './Components/SlideoutInbox';\nimport { Inbox } from './index';\n\nconst AdditionalDetails: React.FC<DetailsSectionsProps> = (props) => {\n    return (\n        <>\n            <Typography variant='h6'>Additional Data</Typography>\n            <List>\n                {Object.entries(props.notification.additionalData ?? {}).map(([key, value]) => (\n                    <ListItem key={key}>{`${key}: ${value}`}</ListItem>\n                ))}\n            </List>\n        </>\n    );\n};\n\nexport default (): React.ReactElement => {\n    const detailsOptions: DetailsOptions = {\n        additionalDetails: (props) => <AdditionalDetails notification={props.notification} />,\n    };\n\n    return (\n        <Inbox\n            options={{\n                details: detailsOptions,\n            }}\n        />\n    );\n};\n";